import {
  Building2,
  ClipboardList,
  FileText,
  Landmark,
  LineChart,
  Scale,
  Search,
  ShieldAlert,
  Target,
  TrendingUp,
  Users,
  Zap,
  type LucideIcon,
} from "lucide-react";

/**
 * The icons an analysis may carry.
 *
 * Stored as a lucide component *name*, not an emoji — which is easy to get wrong,
 * since the name is a plain string and rendering it directly shows the word
 * "FileText" beside the analysis. Everything that displays an analysis goes
 * through `analysisIcon`.
 *
 * The AI drafter picks from these same names, so the set is a contract: adding
 * one here without telling the drafter just means it never chooses it, which is
 * harmless. Removing one falls back to FileText.
 */
export const ANALYSIS_ICONS: Record<string, LucideIcon> = {
  FileText,
  Zap,
  TrendingUp,
  Target,
  ShieldAlert,
  Users,
  Landmark,
  LineChart,
  Scale,
  Search,
  ClipboardList,
  Building2,
};

export const DEFAULT_ANALYSIS_ICON = "FileText";

export const analysisIcon = (name?: string): LucideIcon =>
  ANALYSIS_ICONS[name ?? DEFAULT_ANALYSIS_ICON] ?? FileText;

/** The names the AI drafter is allowed to return. */
export const ANALYSIS_ICON_NAMES = Object.keys(ANALYSIS_ICONS);
